import { LS_LAST_MESSAGE_SENT_AT } from '../../common/constants/private';

export const setLastMessageSentAt = (timestamp: number | null): void => {
	if (timestamp === null) {
		localStorage.removeItem(LS_LAST_MESSAGE_SENT_AT);
		return;
	}

	localStorage.setItem(LS_LAST_MESSAGE_SENT_AT, timestamp.toString());
};
